module.exports = __webpack_public_path__ + "static/media/padling.cc9f0e47.svg";